import { createContext } from 'react';

import { FormatterWithPrecision } from '../../core/types/formatter.js';

export const TimeseriesYFormatterContext = createContext<
  FormatterWithPrecision[] | undefined
>(undefined);

TimeseriesYFormatterContext['displayName'] = 'TimeseriesYFormatterContext';
